import { useEffect, useRef, useState } from 'react'

import { DSButton, DSCircularLoading, DSModal, DSText } from '@vr/ds-react'
import { FormProvider, useForm } from 'react-hook-form'

import { Justification } from '../justification'
import ModalError from '@/components/modal-error'
import ModalSuccess from '@/components/modal-success'
import { useCollectContext } from '@/contexts/collect.context'
import { useRejectPatch } from '@/hooks/use-reject-patch'

type FormValues = {
  collectId?: string
  recusadoPor?: string
  itensRecusados?: string[]
  justificativa: string
  username?: string
}

const ModalReject = ({
  id,
  collectId,
  onClose = () => {}
}: {
  id: string
  collectId?: string
  onClose?: () => void
}) => {
  const [accountKey, setAccountKey] = useState(Date.now())
  const formRef = useRef<HTMLFormElement>(null)
  const [modalError, setModalError] = useState(false)
  const [modalSuccess, setModalSuccess] = useState(false)
  const { handleFilter, currentFilters } = useCollectContext()
  const { rejectPatch, isLoading } = useRejectPatch()

  const userString = localStorage.getItem('user')
  const user = userString ? JSON.parse(userString) : {}
  const userId = user?.userId

  const methods = useForm<FormValues>({
    defaultValues: {
      justificativa: ''
    }
  })

  useEffect(() => {
    setAccountKey(Date.now())
  }, [])

  const onSubmit = async (data: FormValues) => {
    const response = await rejectPatch({
      collectId: collectId,
      recusadoPor: userId,
      itensRecusados: [id],
      motivoRecusa: data.justificativa
    })

    if (response?.sucesso) {
      setModalSuccess(true)
      return
    }

    setModalError(true)
  }

  return (
    <>
      <DSModal config={{ show: !modalSuccess, onClose }} css={{ width: '500px' }}>
        <FormProvider {...methods}>
          <form
            id='form-request-logistics'
            onSubmit={methods.handleSubmit(onSubmit)}
            ref={formRef}
          >
            <DSModal.Header onClose={onClose}>Recusar</DSModal.Header>
            <DSModal.Body>
              {isLoading ? (
                <DSCircularLoading isLoading shouldBlur={false} />
              ) : (
                <Justification methods={methods} accountKey={accountKey} />
              )}
            </DSModal.Body>
            <DSModal.Footer css={{ display: 'flex', justifyContent: 'center' }}>
              <DSButton variant='primary' type='submit'>
                Enviar
              </DSButton>
            </DSModal.Footer>
          </form>
        </FormProvider>
      </DSModal>

      <ModalSuccess isOpen={modalSuccess} title='Sucesso' onClose={() => { handleFilter(currentFilters); onClose() }}>
        <DSText>Recusa realizada com sucesso.</DSText>
      </ModalSuccess>

      <ModalError isOpen={modalError} title='Erro' onClose={onClose}>
        <DSText>
          Ocorreu um erro ao recusar a solicitação. Por favor, tente novamente
          mais tarde.
        </DSText>
      </ModalError>
    </>
  )
}

export default ModalReject
